export const TOASTER_TIMEOUT = 2500;
export enum ToasterVariant {
    INFO = 'info',
    FAILURE = 'failure',
    SUCCESS = 'success',
}
